import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import { Text } from "../../types";
import { getMinutesRoundedTimestamp } from "../../utils";
import ImageBorderBox from "../ui/BorderBox";
import ModalDialog from "../ui/ModalDialog";
import styles from "./SimpleTextModalDialog.module.css";

interface SimpleTextModalDialogProps {
  title: string;
  text: Text;
  isOpen: boolean;
  onClose: () => void;
}

const SimpleTextModalDialog: FC<SimpleTextModalDialogProps> = ({
  title,
  text,
  isOpen,
  onClose,
}: SimpleTextModalDialogProps) => {
  const i18n = useI18n();
  return (
    isOpen && (
      <ModalDialog
        title={title}
        onClose={onClose}
        isSubmitting={false}
        actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
      >
        <ImageBorderBox description={text.value} className={styles.textDialog}>
          {text.image ? (
            <div className={styles.img}>
              <ImageBorderBox.Image
                src={`${import.meta.env.VITE_BUCKET_URL}${text.image}?${getMinutesRoundedTimestamp()}`}
              />
            </div>
          ) : undefined}
        </ImageBorderBox>
      </ModalDialog>
    )
  );
};

export default SimpleTextModalDialog;
